/* eslint-disable camelcase */
import { axios, get } from './axios';

import { toQuery } from '../utils/oauth';
import { removeAccessToken, setRedirectUrl } from '../utils/storage';
import { UserType } from '../types/user.type';

interface AuthorizeType {
  client_id: string;
  scope: string;
  redirect_uri: string;
  response_type: string;
  state?: string;
}

const contextPath = process.env.REACT_APP_API_VERSION;
const serverUrl = process.env.REACT_APP_OAUTH_DOMAIN;
const authorizationUrl = `${serverUrl}/oauth/authorize`;
const getTokenUrl = `${serverUrl}/oauth/token`;
const clientId = process.env.REACT_APP_CLIENT_ID;
const clientSecret = process.env.REACT_APP_CLIENT_SECRET;
const redirectUri = process.env.REACT_APP_REDIRECT_URI;
const state = '12345';
const scope = 'read';
const responseType = 'code';

const getUserDetail = (): Promise<{ data: UserType }> => {
  return get(`${contextPath}/user/profile`);
};

const getToken = ({ code, onSuccess }: { code: string; onSuccess: () => void }): void => {
  const payload = {
    grant_type: 'authorization_code',
    client_id: clientId,
    client_secret: clientSecret,
    code: code,
    redirect_uri: redirectUri,
  };
  const search = toQuery(payload);
  fetch(`${getTokenUrl}?${search}`)
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
      throw new Error('fetch token error');
    })
    .then((data) => {
      axios.setToken(data);
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

const authorize = (): void => {
  removeAccessToken();
  const payload: AuthorizeType = {
    client_id: clientId,
    scope,
    redirect_uri: redirectUri,
    response_type: responseType,
  };
  if (state) {
    payload.state = state;
  }
  const search = toQuery(payload);
  setRedirectUrl(window.location.href);
  window.location.href = `${authorizationUrl}?${search}`;
};

export { getUserDetail, authorize, getToken, redirectUri, responseType };
